import React from "react";
import { useSelector } from "react-redux";

// ✅ Correct default imports
import logo1 from "../assets/images/Home/screen/gigwLogo 1.jpg";
import logo2 from "../assets/images/Home/screen/w3cxhtm 1.jpg";
import logo3 from "../assets/images/Home/screen/vcss 1.jpg";
import logo4 from "../assets/images/Home/screen/logoIndia 1.jpg";
import logo5 from "../assets/images/Home/screen/MahaIT_Logo 1.jpg";

const ScreenReader = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Screen Reader Access",
      breadcrumb: {
        home: "HOME",
        page: "SCREEN READER ACCESS",
      },
      paragraph: `Directorate of Archaeology and Museums website complies with World Wide Web Consortium (W3C) Web Content Accessibility Guidelines (WCAG) 2.0 level AA. This will enable people with visual impairments access the website using assistive technologies, such as screen readers. The information of the website is accessible with different screen readers.`,
      footer1: "Disclaimer and Policies",
      footer2: "Accessibility Statement",
      footer3: "Help",
      footer4: "Sitemap",
      copyright: `© This is the official website of Cultural Affair Department,
              Maharashtra State, India. All Rights Reserved.`,
    },
    मराठी: {
      title: "स्क्रीन रीडर प्रवेश",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "स्क्रीन रीडर प्रवेश",
      },
      paragraph: `पुरातत्व आणि संग्रहालय संचालनालयाची वेबसाइट वर्ल्ड वाइड वेब कन्सोर्टियम (W3C) वेब कंटेंट अ‍ॅक्सेसिबिलिटी मार्गदर्शक तत्त्वे (WCAG) 2.0 पातळी AA चे पालन करते. यामुळे दृष्टीदोष असलेल्या लोकांना स्क्रीन रीडरसारख्या सहाय्यक तंत्रज्ञानाचा वापर करून वेबसाइटवर प्रवेश करता येईल. वेबसाइटची माहिती वेगवेगळ्या स्क्रीन रीडरद्वारे उपलब्ध आहे.`,
      footer1: "उत्तरदायित्वास नकार आणि धोरणे ",
      footer2: "वापरसुलभता ",
      footer3: "मदत",
      footer4: "संकेतस्थळ मार्गदर्शिका",
      copyright: `© सांस्कृतिक कार्य विभाग यांचे हे अधिकृत संकेतस्थळ आहे. सर्व अधिकार सुरक्षित.`,
    },
  };

  const t = content[selectedLang];

  const tableHeaders = {
    screenReader: {
      English: "Screen Reader",
      मराठी: "स्क्रीन रीडर",
    },
    website: {
      English: "Website",
      मराठी: "वेबसाइट",
    },
    free: {
      English: "Free / Commercial",
      मराठी: "विनामूल्य / व्यावसायिक",
    },
  };

  const commonScreen = [
    {
      id: "screen-1",
      title: {
        English: "Screen Access For All (SAFA)",
        मराठी: "सर्वांसाठी स्क्रीन अ‍ॅक्सेस (SAFA)",
      },
      division: {
        English: "https://safa-reader.software.informer.com/download/",
        मराठी: "https://safa-reader.software.informer.com/download/",
      },
      commercial: {
        English: "Free",
        मराठी: "विनामूल्य",
      },
    },
    {
      id: "screen-2",
      title: {
        English: "Non Visual Desktop Access (NVDA)",
        मराठी: "नॉन व्हिज्युअल डेस्कटॉप अ‍ॅक्सेस (NVDA)",
      },
      division: {
        English: "http://www.nvda-project.org/",
        मराठी: "http://www.nvda-project.org/",
      },
      commercial: {
        English: "Free",
        मराठी: "विनामूल्य",
      },
    },
    {
      id: "screen-3",
      title: {
        English: "System Access To Go",
        मराठी: "सिस्टम अ‍ॅक्सेस टू गो",
      },
      division: {
        English: "http://www.satogo.com/",
        मराठी: "http://www.satogo.com/",
      },
      commercial: {
        English: "Free",
        मराठी: "विनामूल्य",
      },
    },
    {
      id: "screen-4",
      title: {
        English: "Thunder",
        मराठी: "मेघगर्जना",
      },
      division: {
        English: "http://www.screenreader.net/index.php?pageid=2",
        मराठी: "http://www.screenreader.net/index.php?pageid=2",
      },
      commercial: {
        English: "Free",
        मराठी: "विनामूल्य",
      },
    },
    {
      id: "screen-5",
      title: {
        English: "WebAnywhere",
        मराठी: "वेबअनीहीअर",
      },
      division: {
        English: "http://webanywhere.cs.washington.edu/wa.php",
        मराठी: "http://webanywhere.cs.washington.edu/wa.php",
      },
      commercial: {
        English: "Free",
        मराठी: "विनामूल्य",
      },
    },
    {
      id: "screen-6",
      title: {
        English: "Hal",
        मराठी: "हाल",
      },
      division: {
        English: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
        मराठी: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
      },
      commercial: {
        English: "Commercial",
        मराठी: "व्यावसायिक",
      },
    },
    {
      id: "screen-7",
      title: {
        English: "JAWS",
        मराठी: "जॉज़",
      },
      division: {
        English: "http://www.freedomscientific.com/jaws-hq.asp",
        मराठी: "http://www.freedomscientific.com/jaws-hq.asp",
      },
      commercial: {
        English: "Commercial",
        मराठी: "व्यावसायिक",
      },
    },
    {
      id: "screen-8",
      title: {
        English: "Supernova",
        मराठी: "सुपरनोव्हा",
      },
      division: {
        English: "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
        मराठी: "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
      },
      commercial: {
        English: "Commercial",
        मराठी: "व्यावसायिक",
      },
    },
    {
      id: "screen-9",
      title: {
        English: "Window-Eyes",
        मराठी: "विंडो-आयज",
      },
      division: {
        English: "http://www.gwmicro.com/Window-Eyes/",
        मराठी: "http://www.gwmicro.com/Window-Eyes/",
      },
      commercial: {
        English: "Commercial",
        मराठी: "व्यावसायिक",
      },
    },
  ];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-16">
      {/* Heading */}
      <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
        {t.title}
      </h1>

      {/* Breadcrumb */}
      {/* <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-8">
        <span style={{ color: "#DD9827" }}>
          <Link to="/" className="hover:underline">
            {t.breadcrumb.home}
          </Link>{" "}
          /{" "}
        </span>
        {t.breadcrumb.page}
      </p> */}

      {/* Paragraph */}
      <div className="max-w-7xl pt-14 mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black leading-relaxed space-y-4 -mt-4">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] font-futura">
          {t.paragraph}
        </p>
      </div>

      {/* Table Header */}
      <h1 className="text-[26px] py-12 px-2 sm:text-4xl md:text-5xl lg:text-[45px] text-black">
        {selectedLang === "English"
          ? "Various Screen Readers to choose from"
          : "विविध स्क्रीन रीडर पर्याय"}
      </h1>

      {/* Table Section */}
      <div className="max-w-5xl mx-auto overflow-x-auto">
        <div
          className="bg-[#EFEDE0] rounded-xl w-full min-w-[768px]"
          style={{ border: "2px solid #F8D6BF" }}
        >
          <table className="min-w-full text-center text-black text-sm sm:text-base">
            <thead
              className="font-bold tracking-wide"
              style={{ textShadow: "0.3px 0.3px 0 black" }}
            >
              <tr>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.screenReader[selectedLang]}
                </th>
                <th
                  className="py-3 px-4 border-r-2"
                  style={{ borderColor: "#F8D6BF" }}
                >
                  {tableHeaders.website[selectedLang]}
                </th>
                <th className="py-3 px-4" style={{ borderColor: "#F8D6BF" }}>
                  {tableHeaders.free[selectedLang]}
                </th>
              </tr>
            </thead>
            <tbody>
              {commonScreen.map((item) => (
                <tr key={item.id}>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {item.title[selectedLang]}
                  </td>
                  <td
                    className="py-3 px-4 border-t-2 border-r-2 text-blue-600 underline"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    <a
                      href={item.division[selectedLang]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.division[selectedLang]}
                    </a>
                  </td>
                  <td
                    className="py-3 px-4 border-t-2"
                    style={{ borderColor: "#F8D6BF" }}
                  >
                    {item.commercial[selectedLang]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-6">
          {/* Left Links */}
          <div className="text-left text-[#0073C6] text-sm sm:text-base underline space-y-1">
            <div className="space-x-2">
              <a href="/screenreader">{t.footer1}</a>
              <span className="mx-2">|</span>
              <a href="/screenreader">{t.footer2}</a>
              <span className="mx-2">|</span>
              <a href="/screenreader">{t.footer3}</a>
              <span className="mx-2">|</span>
              <a href="/screenreader">{t.footer4}</a>

            </div>
            <p className="text-black text-[16px] pt-2">{t.copyright}</p>
          </div>

          {/* Right Logos */}
          <div className="flex flex-wrap items-center gap-6">
            <img src={logo1} alt="GIGW" className="h-5 sm:h-6 object-contain" />
            <a
              href="https://validator.w3.org/nu/?doc=https://mahaarch.in/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W3C HTML Validator - Valid HTML5"
            >
              <img
                src={logo2}
                alt="Valid HTML5"
                className="h-5 sm:h-6 object-contain hover:opacity-80 transition"
              />
            </a>
            <a
              href="https://jigsaw.w3.org/css-validator/validator?uri=https%3A%2F%2Fmahaarch.in%2F&profile=css3svg&usermedium=all&warning=1&vextwarning="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="W3C CSS Validator - Valid CSS Level 3 + SVG"
            >
              <img
                src={logo3}
                alt="Valid CSS"
                className="h-5 sm:h-6 object-contain hover:opacity-80 transition"
              />
            </a>
            <a
              href="https://www.india.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Government of India Official Portal"
            >
              <img
                src={logo4}
                alt="Government of India"
                className="h-4 sm:h-6 object-contain hover:opacity-80 transition"
              />
            </a>

            <img
              src={logo5}
              alt="MahaIT"
              className="h-10 sm:h-12 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenReader;
